module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"pending_reviews":"作成できるレビュー {count}","written_reviews":"マイレビュー {count}"}}')
  delete Component.options._Ctor
}
